import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../store/types";
import SbuxEnhancedTable from "../../../../../components/SbuxTable/SbuxEnhancedTable";
import RowSource from "./RowSource";
import { columns } from "./columns";
import {
  retrieveApiData,
  deleteApiData,
} from "../../../../../services/connect";
import {
  getConnectDatasetsSelector,
  getConnectStatusSelector,
} from "../../../../../selectors/connectSelector";
import { getInstanceIdSelector } from "../../../../../selectors/userInstanceSelector";

interface Props {
  apiName: string;
}

const ConnectTable = ({ apiName }: Props) => {
  const dispatch = useAppDispatch();

  const instanceId = useAppSelector(getInstanceIdSelector);
  const datasets = useAppSelector(getConnectDatasetsSelector);
  const status = useAppSelector(getConnectStatusSelector);

  const dataset = (datasets?.[apiName] ?? []) as Record<string, unknown>[];
  const [data, setData] = useState<Record<string, unknown>[]>([]);

  const dataRequest = async () => {
    const payload = {
      instanceId: instanceId,
      queryParams: {
        apiName,
      },
    };

    await dispatch(retrieveApiData(payload));
  };

  const handleClickRefreshEvent = async () => {
    if (!status.endsWith("pending")) {
      await dataRequest();
    }
  };

  const handleClickDeleteRowEvent = async (row: Record<string, unknown>) => {
    const payload = {
      instanceId: instanceId ?? "",
      id: row["Id"] as string,
      queryParams: {
        apiName,
      },
    };

    await dispatch(deleteApiData(payload));
  };

  useEffect(() => {
    if (Array.isArray(dataset) && dataset.length > 0) {
      setData(dataset);
    }
  }, [dataset]);

  useEffect(() => {
    dataRequest();
  }, [instanceId]);

  return (
    <SbuxEnhancedTable
      rows={data}
      columns={columns}
      defaultSortingField={"Name"}
      defaultSortOrder={"asc"}
      RowSource={RowSource}
      showFooter={true}
      showSearchBar={true}
      showRefreshButton={true}
      isManager={true}
      handleRefreshClick={handleClickRefreshEvent}
      handleDeleteRowClick={handleClickDeleteRowEvent}
    />
  );
};

export default ConnectTable;
